import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdShare } from 'react-icons/md';

const Transfer: React.FC<IconBaseProps> = (props) => <MdShare {...props} />;

export default Transfer;
